import { makeActionCreator } from 'crazyEditor/redux/helpers';

export const HIDE_MOBILE_ELEMENT = 'crazyEditor/element/HIDE_MOBILE_ELEMENT';
export const SHOW_MOBILE_ELEMENT = 'crazyEditor/element/SHOW_MOBILE_ELEMENT';
export const SET_MOBILE_ELEMENTS = 'crazyEditor/element/SET_MOBILE_ELEMENTS';
export const ADD_MOBILE_ELEMENTS_FIRST_STEP = 'crazyEditor/element/ADD_MOBILE_ELEMENTS_FIRST_STEP';
export const ADD_MOBILE_ELEMENTS_SECOND_STEP = 'crazyEditor/element/ADD_MOBILE_ELEMENTS_SECOND_STEP';
export const ADD_MOBILE_ELEMENTS_THIRD_STEP = 'crazyEditor/element/ADD_MOBILE_ELEMENTS_THIRD_STEP';
export const RESIZE_MOBILE_ELEMENTS = 'crazyEditor/element/RESIZE_MOBILE_ELEMENTS';
export const UPDATE_MOBILE_ELEMENT = 'crazyEditor/element/UPDATE_MOBILE_ELEMENT';

export function updateMobileElement(ids, elementProps = {}) {
  return {type: UPDATE_MOBILE_ELEMENT, ids, elementProps};
}
export const hideMobileElement = makeActionCreator(HIDE_MOBILE_ELEMENT, 'ids');
export const showMobileElement = makeActionCreator(SHOW_MOBILE_ELEMENT, 'id');
// export const setMobileElements = makeActionCreator(SET_MOBILE_ELEMENTS, 'elements');
export const addMobileElementsFirstStep = makeActionCreator(ADD_MOBILE_ELEMENTS_FIRST_STEP, 'elements');
export const addMobileElementsSecondStep = makeActionCreator(ADD_MOBILE_ELEMENTS_SECOND_STEP);
export const addMobileElementsThirdStep = makeActionCreator(ADD_MOBILE_ELEMENTS_THIRD_STEP);
export const resizeMobileElements = makeActionCreator(RESIZE_MOBILE_ELEMENTS);
